export default '/build/d54c4ae7.jpg'